import React from "react";
import { STRAPI_ASSETS_BASE_PATH } from "./utils";
const loaderImage = `${STRAPI_ASSETS_BASE_PATH}spinner_3335a3ead8.gif`;
function Loader() {
  return (
    <div className="overlay">
      <div className="loader-wrapper">
        <img
          className="mx-3"
          src={loaderImage}
          alt="Loading..."
          width={80}
          height={80}
        />
      </div>
    </div>
  );
}

export default Loader;
